<template>
  <header-layout
    title = "Page not found"
    subtitle = "Error code 404"
    :displayBreadcrumb = false
  />

  <section>
    <div class="container">
      <single-block>
        <error-alert>
          The server was not able to load the requested page.
        </error-alert>
      </single-block>
    </div>
  </section>

  <footer-layout />
</template>

<script>
  import HeaderLayout from "@/components/layouts/Header.vue"
  import FooterLayout from "@/components/layouts/Footer.vue"
  import SingleBlock from "@/components/blocks/Single.vue"
  import ErrorAlert from "@/components/alerts/Error.vue"

  export default {
    name: "PageNotFoundErrorView",
    components: {
      HeaderLayout,
      FooterLayout,
      SingleBlock,
      ErrorAlert,
    }
  }
</script>
